import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";
import { Grid, GridColumn } from "@progress/kendo-react-grid";

export function HistoryModal(props) {
  const {
    show,
    title,
    handleClose,
    gridData,
    gridColumns,
    gridDataState,
    gridResultState,
    onDataStateChange,
  } = props;

  function CreateGridColumn(column) {
    if (column.hidden) {
      return null;
    }

    if (column.type === "date") {
      return (
        <GridColumn
          key={column.accessor + "Column"}
          field={column.accessor}
          title={column.title}
          filter="date"
          format="{0:d}"
        />
      );
    } else if (column.type === "money") {
      return (
        <GridColumn
          key={column.accessor}
          filter={"numeric"}
          field={column.accessor}
          title={column.title}
          format="{0:c}"
        />
      );
    } else {
      return (
        <GridColumn
          key={column.accessor + "Column"}
          filter={"text"}
          field={column.accessor}
          title={column.title}
        />
      );
    }
  }

  return (
    <Modal
      className="grid-remittance-history-modal"
      show={show}
      onHide={handleClose}
      enforceFocus={false}
    >
      <Modal.Header>
        <h3>{title}</h3>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col className="tight-grid multi-line-filter">
            <Grid
              data={gridResultState}
              filterable={true}
              sortable={true}
              groupable={true}
              pageable={true}
              onDataStateChange={onDataStateChange}
              {...gridDataState}
            >
              {gridColumns.length > 0
                ? gridColumns.map((singleColumn) =>
                    CreateGridColumn(singleColumn)
                  )
                : ""}
            </Grid>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export function EditConfirmationModal(props) {
  const { show, title, children, handleClose, handleOk } = props;

  return (
    <Modal show={show} onHide={handleClose} enforceFocus={false}>
      <Modal.Header>
        <h4>{title}</h4>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleOk}>
          Ok
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
